var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"scroll-board"}},[(_vm.config.data.length > 0)?_c('dv-scroll-board',{attrs:{"config":_vm.config}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }